import type { BrowseTrack } from "@touchscreen/api-client";
import { Artwork } from "@touchscreen/brand-kit";
import { artworkUrl } from "../lib/artwork.js";
import "./ConfirmRequestModal.css";

export interface ConfirmRequestModalProps {
  track: BrowseTrack;
  submitting: boolean;
  /** Blocks confirming outright — e.g. this device's own recent-request hint. */
  disabledReason?: string | null;
  /** Shown but does not block a retry — e.g. the previous attempt's server error. */
  errorMessage?: string | null;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmRequestModal(props: ConfirmRequestModalProps): React.JSX.Element {
  const { track, submitting, disabledReason, errorMessage, onConfirm, onCancel } = props;
  return (
    <div className="confirm-modal" role="dialog" aria-modal="true">
      <div className="confirm-modal__card">
        <p className="confirm-modal__eyebrow">Request this track?</p>
        <Artwork className="confirm-modal__artwork" src={track.artwork_ref ?? artworkUrl(track.sm_id)} />
        <h2 className="confirm-modal__title">{track.title}</h2>
        <h3 className="confirm-modal__artist">{track.artist}</h3>
        {disabledReason ? <p className="confirm-modal__reason">{disabledReason}</p> : null}
        {!disabledReason && errorMessage ? <p className="confirm-modal__reason">{errorMessage}</p> : null}
        <div className="confirm-modal__actions">
          <button className="confirm-modal__cancel" onClick={onCancel} disabled={submitting}>
            Cancel
          </button>
          <button className="confirm-modal__confirm" onClick={onConfirm} disabled={submitting || Boolean(disabledReason)}>
            {submitting ? "Requesting…" : "Request"}
          </button>
        </div>
      </div>
    </div>
  );
}
